import moment from 'moment';
import React from 'react';
import { EpisodeAsset } from '../../../../queries/ats/titles/types/asset';
import { Source } from '../../../../queries/ats/titles/types/sources';
import { InfoLine } from '../../info-line/info-line';
import css from './episode-info-line.module.scss';

interface EpisodeInfoLineProps {
  episode: EpisodeAsset;
  source: Source;
}

export function EpisodeInfoLine({ episode, source }: EpisodeInfoLineProps) {
  if (source.type === 'program') {
    return (
      <InfoLine
        asset={episode}
        source={source}
        captions={['airtime', 'runtime', 'year', 'genres', 'rating']}
        className={css.info}
      />
    );
  }

  if (source.type === 'thirdparty' && moment().isBefore(source.availableFrom)) {
    return (
      <InfoLine
        asset={episode}
        source={source}
        captions={['airtime', 'runtime', 'year', 'genres', 'rating']}
        className={css.info}
      />
    );
  }

  return (
    <InfoLine asset={episode} source={source} captions={['runtime', 'year', 'genres', 'rating']} className={css.info} />
  );
}
